export default __webpack_public_path__ + "static/media/arrow-left.736aacf3.svg";